module.exports = __webpack_public_path__ + "static/media/circle-down.03893da8.svg";